// PR-39 (Phase 1) — Post/story video kaynak resolver'ı (backward-compatible).
//
// AMAÇ: Post/story videolarını R2/CDN'e taşımanın CLIENT tarafını, mevcut
// davranışı BİRE BİR bozmadan hazırlamak. Bugün doc'larda `cdnUrl` YOK →
// resolver eski Firebase Storage `mediaUrl`'ini döner (davranış değişmez).
// Phase 2'de yeni upload'lar `videoProvider:"r2"` + `cdnUrl` yazınca resolver
// otomatik CDN'i tercih eder — okuyucu tarafında EK KOD gerekmez.
//
// MyClips V3 ile ALAKASIZ (o kendi v3_r2Url/transformR2Url hattını kullanır;
// bu resolver yalnız posts/hikayeler Firebase Storage medyası içindir).
//
// Pure helper: Firebase çağrısı YOK. transformR2Url mevcut util'i R2 dev-host
// URL'lerini kalıcı CDN'e çevirir (yoksa null → fallback zinciri).
import { transformR2Url } from "./r2Url";

/**
 * Video kaynak nesnesi — post doc, carousel media item veya story doc olabilir.
 * Öncelik: CDN alanları (Phase 2) → eski Firebase Storage alanları.
 */
export interface VideoSourceLike {
  cdnUrl?: string | null;
  videoCdnUrl?: string | null;
  mediaCdnUrl?: string | null;
  mediaUrl?: string | null;
  videoUrl?: string | null;
  url?: string | null;
  [key: string]: any;
}

/**
 * Oynatılacak video URL'ini çöz. Sıra:
 *   1) CDN alanı (cdnUrl/videoCdnUrl/mediaCdnUrl) → transformR2Url ile normalize
 *   2) Eski Firebase Storage alanı (mediaUrl/videoUrl/url)
 * Hiçbiri yoksa "" (çağıran mevcut boş-davranışını korur).
 */
export function resolveVideoUrl(source?: VideoSourceLike | null): string {
  if (!source || typeof source !== "object") return "";
  const cdnRaw = source.cdnUrl || source.videoCdnUrl || source.mediaCdnUrl || "";
  if (cdnRaw) {
    const cdn = transformR2Url(cdnRaw);
    if (cdn) return cdn;
    // transformR2Url null döndürdüyse (kırık r2.dev host, rewrite yok) →
    // eski Firebase alanına düş (aşağıda).
  }
  return source.mediaUrl || source.videoUrl || source.url || "";
}
